import { Subject } from "rxjs";

export class OverlayRef {
	private onBackdropClick$ = new Subject<void>();

	onBackdropClick() {
		this.onBackdropClick$.next();
		this.onBackdropClick$.complete();
	}

	get backdropClick$() {
		return this.onBackdropClick$.asObservable();
	}
}
